<form [formGroup]="form">
  <div class="p-fluid">
    <kodit-field fieldLabel="Dodatni prilog/prilozi" fieldLabelFor="attachment">
      <kodit-file-upload
        (onUpload)="handleUpload($event)"
        fileTypes=".xml,.jpg,.png,.jpeg,.pdf"
        [shouldAutoUpload]="true"
        [allowMultipleFiles]="true"
      ></kodit-file-upload>
    </kodit-field>
  </div>
</form>
